import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';

const divisionSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});
const documentStatusSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});
const paymentTypeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});
const deliveryTypeSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});
const traderSchema = z.object({
  code: z.string().optional(),
  id: z.string(),
  name: z.string().optional(),
  taxNumber: z.string().optional(),
  city: z.string().optional(),
  address: z.string().optional(),
  zipCode: z.string().optional(),
});
const documentSeriesTypeSchema = baseObjectSchema.extend({
  documentTypeID: z.string(),
  documentSeriesID: z.string(),
  defaultWarehouseID: z.string().optional(),
  documentType: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    })
    .optional(),
  documentSeries: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    })
    .optional(),
  defaultWarehouse: z
    .object({
      id: z.string(),
      code: z.string(),
      name: z.string(),
    })
    .optional(),
  sequenceFormat: z.string().optional(),
  isDefault: z.number(),
  recordMode: z.number().optional(),
});

export const getDocumentTypesSchema = z.array(
  baseObjectSchema.extend({
    code: z.string().optional(),
    name: z.string().optional(),
    description: z.string().optional(),
    takeDigitalSignature: z.boolean(),
    mergedSameDocumentLines: z.boolean(),
    usePaymentTypes: z.boolean(),
    supportLoyalty: z.boolean(),
    allowManualPrices: z.boolean(),
    allowZeroQty: z.boolean(),
    allowZeroValues: z.boolean(),
    allowDynamicRange: z.boolean(),
    allowEditClosedDocuments: z.boolean(),
    maxDetailQty: z.number().optional(),
    maxDetailUnitPrice: z.number().optional(),
    maxDetailTotal: z.number().optional(),
    maxPaymentAmount: z.number().optional(),
    companyID: z.string(),
    divisionID: z.string(),
    requireWarehouse: z.boolean().optional(),
    requirePaymentType: z.boolean().optional(),
    requireDeliveryType: z.boolean().optional(),
    allowHeaderDiscounts: z.boolean().optional(),
    defaultDocumentStatusID: z.string().optional(),
    defaultPaymentTypeID: z.string().optional(),
    defaultDeliveryTypeID: z.string().optional(),
    defaultTraderID: z.string().optional(),
    division: divisionSchema.optional(),
    defaultDocumentStatus: documentStatusSchema.optional(),
    defaultPaymentType: paymentTypeSchema.optional(),
    defaultDeliveryType: deliveryTypeSchema.optional(),
    defaultTrader: traderSchema.optional(),
    documentSeriesType: z.array(documentSeriesTypeSchema).optional(),
    daysToDelivery: z.number().optional(),
    defaultReportingTemplateId: z.string().optional(),
    syncWithMyData: z.boolean(),
    totalMeasurementUnits: z.number().optional(),
    columnDefinitions: z.string().optional(),
    parentDocumentTypeId: z.string().optional(),
    parentDocumentType: baseSchema.optional(),
  })
);

export type GetDocumentTypesResponse = z.infer<typeof getDocumentTypesSchema>;
